import { torefarmMainPeople } from './index';

const torefarmMain = () => {

  const pageTorefarm = document.getElementById('pageTorefarm');
  if (pageTorefarm) {

    let sW = window.innerWidth;
    let sH = window.innerHeight;
    let header = document.querySelector('header.header');
    let secMain = document.getElementById('jsSecMain');

    let main = secMain.querySelectorAll('.js-main');
    let peopleBox = secMain.querySelectorAll('.js-people-box');

    let ttlWrap = secMain.querySelectorAll('.js-ttl-wrap');


    if (!(sW > 750)) {
      let headerH = header.clientHeight
      secMain.style.height = `${sH - headerH}px`
    }


    let mainGround = [
      main[0],
    ]
    let mainObject1 = [
      main[1],
    ]
    let mainObject2 = [
      main[2],
      main[3],
      main[4],
      main[5],
      main[6],
      main[7],
    ]

    gsap.set(mainGround, {
      y: 20,
      opacity: 0,
    });
    gsap.set(mainObject1, {
      y: 20,
      opacity: 0,
    });
    gsap.set(mainObject2, {
      y: 20,
      opacity: 0,
    });


    const mainAnime = () => {
      let tl = gsap.timeline()
      tl.to(mainGround, {
        y: 0,
        opacity: 1,
        duration: .5,
        ease: 'Power1.easeInOut',
      })
        .to(mainObject1, {
          y: 0,
          opacity: 1,
          duration: .5,
          ease: 'Power1.easeInOut',
          stagger: {
            // amount: 0.5,
            each: 0.1,
            from: "random",
          },
        }, '+=0.5')
        .to(mainObject2, {
          y: 0,
          opacity: 1,
          duration: .5,
          ease: 'Power1.easeInOut',
          stagger: {
            // amount: 0.2,
            each: 0.1,
            from: "random",
          },
        }, '+=0.5')
        .to(ttlWrap, {
          opacity: 1,
          duration: .5,
          ease: 'Power1.easeInOut',
          onComplete: () => {
            peopleAct()
            torefarmMainPeople()
          },
        }, '+=0.5')
    }
    
    
    const peopleAct = () => {
      setTimeout(() => {
        for (let i = 0; i < peopleBox.length; i++) {
          peopleBox[i].classList.add('act')
          console.log(peopleBox[i]);
        }
      }, 0)
    }

    
    ttlWrap[0].classList.add('act')
    setTimeout(mainAnime, 1000)


  }
};
export default torefarmMain;